export const tabbableSelector =
    "[contentEditable=true], [contentEditable=plaintext-only], details>summary:first-of-type, a[href], [tabindex], audio[controls], video[controls], button, textarea, select, input:not([type='hidden'])";
